// AnalyticsHeader.tsx
import React from 'react';
import { Tabs, Tab, Typography, Box, Container, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { analyticsConfig } from './config/analyticsConfig';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid #e8e8e8',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3
  },
}));

const StyledTab = styled(Tab)(({ theme, color }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: 'rgba(0, 0, 0, 0.7)',
  '&.Mui-selected': {
    color: color || analyticsConfig.activeColor,
    fontWeight: theme.typography.fontWeightMedium,
    borderBottom: `3px solid ${color || analyticsConfig.activeColor}`,
  },
  '&:hover': {
    color: color || analyticsConfig.defaultColor,
    opacity: 1,
  },
}));

const HeaderContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'none',
  borderBottom: '1px solid #e8e8e8',
  marginBottom: theme.spacing(3)
}));

const TitleSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 0),
  backgroundColor: theme.palette.background.paper,
}));

function AnalyticsHeader({ visibleTabs = [], activeTabId, onTabChange }) {
  if (!visibleTabs.length || !activeTabId) {
    return null;
  }

  const activeIndex = Math.max(
    0,
    visibleTabs.findIndex((tab) => tab.id === activeTabId)
  );
  const activeTab = visibleTabs[activeIndex];

  const handleChange = (event, newValue) => {
    const tab = visibleTabs[newValue];
    if (tab && onTabChange) {
      onTabChange(tab.id);
    }
  };

  return (
    <HeaderContainer>
      <Container maxWidth="xl" sx={{ marginLeft: 0 }}>
        <TitleSection>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: activeTab.color }}>
            {activeTab.label}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {analyticsConfig.subtitle}
          </Typography>
        </TitleSection>
        <StyledTabs
          value={activeIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            style: { display: 'none' }
          }}
        >
          {visibleTabs.map((tab) => (
            <StyledTab
              key={tab.id}
              label={tab.label}
              color={tab.color || analyticsConfig.defaultColor}
            />
          ))}
        </StyledTabs>
      </Container>
    </HeaderContainer>
  );
}

export default AnalyticsHeader;
